import React from 'react'
import classes from "./index.module.css";
import { Paper, Typography } from "@mui/material";
const Policy = () => {
    return (
        <div style={{ marginTop: "20px" }}>
            <Paper style={{ padding: "30px" }}>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    1. Introduction to Privacy Policy
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    This privacy policy (the "PRIVACY POLICY") applies to your use of the
                    website of Igloo Digital Technologies Pvt Ltd hosted at
                    www.teamplayer.in, its Services and Team player application on mobile
                    platforms (Android, Blackberry, Windows Phone, iOS etc.) (Hereinafter
                    referred to as “Igloo Digital Technologies Pvt Ltd" or “Team Player"
                    or “Website”).
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    The terms "WE", "OUR" and "US" refer to Igloo Digital Technologies Pvt
                    Ltd and the terms "YOU", "YOUR" and "USER" refer to you, as a User of
                    Team Player. The term "PERSONAL INFORMATION" means information that
                    you provide to us which personally identifies you to be contacted or
                    identified, such as your name, phone number, email address, and any
                    other data that is tied to such information. Our practices and
                    procedures in relation to the collection and use of Personal
                    Information have been set-out below in order to ensure safe usage of
                    the Website for you.{" "}
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We have implemented reasonable security practices and procedures that
                    are commensurate with the information assets being protected and with
                    the nature of our business. While we try our best to provide security
                    that is better than the industry standards, because of the inherent
                    vulnerabilities of the internet, we cannot ensure or warrant complete
                    security of all information that is being transmitted to us by you. By
                    visiting this Website, you agree and acknowledge to be bound by this
                    Privacy Policy and you hereby consent that we will collect, use,
                    process and share your Personal Information in the manner set out
                    herein below. If you do not agree with these terms, do not use the
                    Website. It is clarified that the terms and conditions that are
                    provided separately, form an integral part of your use of this Website
                    and should be read in conjunction with this Privacy Policy.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    2. Information we collect and how we use it{" "}
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We collect, receive and store your company information. You may opt to
                    not provide us with certain information; however, that will restrict
                    you from registering with us or availing some of our features and
                    services.
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We use commercially reasonable efforts to ensure that the collection
                    of information is limited to that which is necessary to fulfill the
                    purposes identified below. If we use or plan to use your information
                    in a manner different than the purpose for which it is collected, then
                    we will ask you for your consent prior to such use.{" "}
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    The information collected will be used only for the purpose of
                    enabling you to use the services provided by us, to help promote a
                    safe service, calibrate consumer interest in our products and
                    services, inform you about online offers and updates, troubleshoot
                    problems, customize User experience, detect and protect us against
                    error, fraud and other criminal activity, enforce our terms and
                    conditions, and as otherwise described to you at the time of
                    collection of such information.{" "}
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    3. Account information
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    If you create an account to take advantage of the full range of
                    services offered by Igloo Digital Technologies Pvt Ltd, we ask for and
                    record your and your employees’ Personal Information such as your
                    name, email address and mobile number. We may collect and store your
                    Sensitive Personal Data or Information (such as any financial
                    information including inter alia credit card, debit card details, bank
                    account and know your customer ("KYC") documents and any other
                    information as may be applicable) that the User may opt to save in the
                    User account created with Igloo Digital Technologies Pvt Ltd]. We use
                    your email address to send you updates, offers, news, and newsletters.
                    [If you do not want to receive communications from us that are not
                    relevant to you or your use of our services, please click on the
                    unsubscribe link provided at the bottom of such e-mails sent to you by
                    us. We use your mobile numbers to send you transaction alerts and SMS
                    alerts based on your preferences. If you do not wish to receive such
                    SMSs from us, please notify us at support@teamplayer.in to stop
                    receiving SMSs from us. Igloo Digital Technologies Pvt Ltd assures
                    that your Personal Information will not be made public or sold to any
                    third party. The User shall have an option to erase any information
                    provided by the User including Personal Information. If a User opts
                    for the said option of erasure, Igloo Digital Technologies Pvt Ltd
                    shall delete all stored information of the User from its servers.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    4. Feedback
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    If you contact us to provide feedback, register a complaint, or ask a
                    question, we will record any Personal Information and other content
                    that you provide in your communication so that we can effectively
                    respond to your communication.
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We record information relating to your use of Team Player, such as the
                    searches you undertake, the pages you view, your browser type, IP
                    address, location, requested URL, referring URL, and timestamp
                    information. We use this type of information to administer Team Player
                    and provide the highest possible level of security and service to you.
                    We also use this information in the aggregate to perform statistical
                    analyses of User behaviour and characteristics in order to measure
                    interest in and use of the various areas of Team Player. However, you
                    cannot be identified from this aggregate information.{" "}
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    5. Activity
                </Typography>
                <Typography className={`${classes.form_lable}`}>
                    We own all the intellectual property rights associated with the
                    Website, app and its contents. No right, title or interest in any
                    downloaded material is transferred to you as a result of any such
                    downloading or copying. The Website is protected by copyright as a
                    collective work and/or compilation (meaning the collection,
                    arrangement, and assembly) of all the content on this Website,
                    pursuant to applicable law.
                </Typography>
                <Typography className={`${classes.form_lable}`}>
                    Our logos, product and service marks and/or names, trademarks,
                    copyrights and other intellectual property, whether registered or not
                    ("OUR IP") are exclusively owned by us. Without our prior written
                    permission, you agree to not display and/or use Our IP in any manner.
                    Nothing contained in this Website or the content, should be construed
                    as granting, in any way to the User, any license or right or interest
                    whatsoever, in and/or to Our IP, without our express written
                    permission.{" "}
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    6. Cookies
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We send cookies to your computer in order to uniquely identify your
                    browser and improve the quality of our service. The term "cookies"
                    refers to small pieces of information that a website sends to your
                    computer's hard drive while you are viewing the site. We may use both
                    session cookies (which expire once you close your browser) and
                    persistent cookies (which stay on your computer until you delete
                    them). Persistent cookies can be removed by following your browser
                    help file directions. If you choose to disable cookies, some areas of
                    Team Player may not work properly or at all. Igloo Digital
                    Technologies Pvt Ltd uses third party tools, who may collect anonymous
                    information about your visits to Team Player using cookies, and
                    interaction with Team Player products and services. Such third parties
                    may also use information about your visits to Team Player products and
                    services and other web sites to target advertisements for Team
                    Player's products and services. No Personal Information is collected
                    or used in this process. These third parties do not know or have
                    access to the name, phone number, address, email address, or any
                    Personal Information about Team Player's Users. Team Player Users can
                    opt-out of sharing this information with third parties by deactivating
                    cookies, the process of which varies from browser to browser. Please
                    refer to the help file of your browser to understand the process of
                    deactivating cookies on your browser.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    7. Enforcement
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We may use the information we collect in connection with your use of
                    Team Player (including your Personal Information) in order to
                    investigate, enforce, and apply our terms and conditions and Privacy
                    Policy.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    8. Transfer of information
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    We do not share your Personal Information with any third party apart
                    from regulatory agencies (as may be required) and to provide you with
                    services that we offer through Team Player, conduct quality assurance
                    testing, facilitate creation of accounts, provide technical and
                    customer support, or provide specific services, such as
                    synchronization of your contacts with other software applications, in
                    accordance with your instructions. These third parties are required
                    not to use your Personal Information other than to provide the
                    services requested by you. We may share your Personal Information with
                    our parent company, subsidiaries, joint ventures, or other companies
                    under a common control (collectively, the "AFFILIATES") that we may
                    have now or in the future, in which case we will require them to
                    honour this Privacy Policy. If another company acquires our company or
                    our assets, that company will possess your Personal Information, and
                    will assume the rights and obligations with respect to that
                    information as described in this Privacy Policy. We may disclose your
                    Personal Information to third parties in a good faith belief that such
                    disclosure is reasonably necessary to (a) take action regarding
                    suspected illegal activities; (b) enforce or apply our terms and
                    conditions and Privacy Policy; (c) comply with legal process, such as
                    a search warrant, subpoena, statute, or court order; or (d) protect
                    our rights, reputation, and property, or that of our Users,
                    Affiliates, or the public. Please note that we are not required to
                    question or contest the validity of any search warrant, subpoena or
                    other similar governmental request that we receive. We may disclose
                    information in the aggregate to third parties relating to User
                    behaviour in connection with actual or prospective business
                    relationship with those third parties, such as advertisers and content
                    distributors. For example, we may disclose the number of Users that
                    have been exposed to, or clicked on, advertising banners.{" "}
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    9. Security
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Your account is password protected. We use industry standard measures
                    to protect the Personal Information that is stored in our database. We
                    limit the access to your Personal Information to those employees and
                    contractors who need access to perform their job function, such as our
                    customer service personnel. If you have any questions about the
                    security on Team Player, please contact us at support@teamplayer.in
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    You hereby acknowledge that Igloo Digital Technologies Pvt Ltd is not
                    responsible for any intercepted information sent via the internet, and
                    you hereby release us from any and all claims arising out of or
                    related to the use of intercepted information in any unauthorized
                    manner.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    10. modifications
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Our Privacy Policy is subject to change at any time without notice. To
                    make sure you are aware of any changes, please review this policy
                    periodically. These changes will be effective immediately on the Users
                    of Igloo Digital Technologies Pvt Ltd. Please note that at all times
                    you are responsible for updating your Personal Information, including
                    providing us with your most current e-mail address.
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    If you do not wish to permit changes in our use of your Personal
                    Information, you must notify us promptly that you wish to deactivate
                    your account with us. Continued use of Igloo Digital Technologies Pvt
                    Ltd after any change/ amendment to this Privacy Policy shall indicate
                    your acknowledgement of such changes and agreement to be bound by the
                    terms and conditions of such changes.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    11. Applicable law
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Your use of this Website will be governed by and construed in
                    accordance with the laws of India. The Users agree that any legal
                    action or proceedings arising out of your use may be brought
                    exclusively in the competent courts/ tribunals having jurisdiction in
                    Mumbai, India and irrevocably submit themselves to the jurisdiction of
                    such courts/tribunals.
                </Typography>
                <Typography className={classes.mainText} sx={{ mb: 2 }}>
                    12. Complaints and Grievance Redressal
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Any complaints or concerns in relation to your Personal Information or
                    content of this Website or any dispute or breach of confidentiality or
                    any proprietary rights of User during use of the Website or any
                    intellectual property of any User should be immediately informed to
                    the Grievance Officer at the co-ordinates mentioned below in writing
                    or by way of raising a grievance ticket through the hyperlink
                    mentioned below:
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Grievance Officer, Igloo Digital Technologies Pvt Ltd
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Address: Plot no. G/01, Office no. 305, Sector 18, Turbhe, Sanpada, Navi Mumbai, Maharashtra – 400705
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    Phone: +918657599000
                </Typography>
                <Typography className={classes.form_lable} sx={{ mb: 3 }}>
                    E-mail: support@teamplayer.in
                </Typography>
            </Paper>
        </div>
    )
}

export default Policy
